function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M17.5381 8.80989C19.1729 8.80989 20.4981 7.48466 20.4981 5.84989C20.4981 4.21513 19.1729 2.88989 17.5381 2.88989C15.9034 2.88989 14.5781 4.21513 14.5781 5.84989C14.5781 7.48466 15.9034 8.80989 17.5381 8.80989Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.46 8.80989C8.09476 8.80989 9.42 7.48466 9.42 5.84989C9.42 4.21513 8.09476 2.88989 6.46 2.88989C4.82524 2.88989 3.5 4.21513 3.5 5.84989C3.5 7.48466 4.82524 8.80989 6.46 8.80989Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5381 21.1099C19.1729 21.1099 20.4981 19.7847 20.4981 18.1499C20.4981 16.5152 19.1729 15.1899 17.5381 15.1899C15.9034 15.1899 14.5781 16.5152 14.5781 18.1499C14.5781 19.7847 15.9034 21.1099 17.5381 21.1099Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M6.46 21.1099C8.09476 21.1099 9.42 19.7847 9.42 18.1499C9.42 16.5152 8.09476 15.1899 6.46 15.1899C4.82524 15.1899 3.5 16.5152 3.5 18.1499C3.5 19.7847 4.82524 21.1099 6.46 21.1099Z",
  fill: "white",
  fillOpacity: 0.4
});

var SvgUtilitiesDark = function SvgUtilitiesDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUtilitiesDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Utilities_dark.f8b9afba.svg";
export { ForwardRef as ReactComponent };